import Immutable from 'immutable';
import {
  FLAG_EXECUTION_REGISTRATION_ACTIVITY,
  CLEAR_EXECUTION_REGISTRATION,
  GET_EXECUTION_REGISTRATION,
} from '../../../actions/types/mechanical-maintenance';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_EXECUTION_REGISTRATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_EXECUTION_REGISTRATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_EXECUTION_REGISTRATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
